
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  width:100%;
}

:host([toplevel]){
  height:100%;
}

:host([toplevel]) .list-item--sub-menu{
    left:0;
  }

:host([toplevel]) .list-item--label{
    font-weight:700;
  }

:host([active]) .list-item--link{
    border-bottom:2px solid var(--color-neutral-darkest);
  }

ul{
  margin:0;
  padding:0;
  list-style:none;
}

li{
  list-style:none;
}

a{
  text-decoration:none;
  color:unset;
}

.list-item{
  display:flex;
  flex-direction:column;
  width:100%;
  color:var(--color-neutral-dark);
  row-gap:1rem;
}

.list-item--link{
  color:var(--color-neutral-dark);
  text-decoration:none;
  width:-moz-fit-content;
  width:fit-content;
}

.list-item--link:hover{
    text-decoration:underline;
  }

.list-item--main{
  display:flex;
  justify-content:center;
  width:100%;
  height:100%;
  align-items:center;
  padding:0 0.5rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  color:var(--color-neutral-dark);
}

.list-item--main[engaged],
.list-item[engaged]{
  background-color:var(--color-blue-100);
}

.list-item[engaged]{
  border-bottom:1px solid var(--blue-900);
}

.list-item--main[engaged] > span,
.list-item--main[engaged] > a{
  color:var(--color-neutral-dark);
  background-color:var(--color-blue-100);
}

.list-item[engaged] > span,
.list-item[engaged] > a{
  color:var(--color-neutral-dark);
}

.list-item--button{
  display:flex;
  justify-content:space-between;
  background:none;
  border:none;
  align-items:center;
  max-width:-moz-fit-content;
  max-width:fit-content;
  color:var(--color-neutral-dark);
}

.list-item--label{
  margin:0;
}

.list-item--label-return{
  color:var(--color-neutral-default);
}

.list-item--sub-menu{
  display:grid;
  width:100%;
  padding:0;
  flex-direction:column;
  min-width:max-content;
  list-style:none;
  row-gap:1rem;
}

.list-item--sub-menu.columns{
    column-gap:2rem;
    display:block;
    column-count:2;
  }

.list-item--sub-menu.columns li:not(:last-of-type){
      margin-bottom:1rem;
    }

.list-item.mobile,
.list-item--main.mobile{
  display:flex;
  width:100%;
  justify-content:space-between;
  flex-direction:column;
  row-gap:0;
  padding:0;
  transition:0.5s;
  position:relative;
}

.list-item.mobile .list-item--button, .list-item--main.mobile .list-item--button{
    max-width:unset;
    width:100%;
    padding:1rem;
  }

.list-item.mobile .list-item--button .list-item--label, .list-item--main.mobile .list-item--button .list-item--label{
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
      text-align:left;
    }

.list-item.mobile li, .list-item--main.mobile li{
    transition:0.5s;
    background-color:var(--color-neutral-white);
  }

@media (prefers-reduced-motion: reduce){
  .list-item.mobile,
  .list-item--main.mobile{
    transition:none;
  }
    .list-item.mobile li, .list-item--main.mobile li{
      transition:none;
    }
}

.list-item--button-icon-mobile:before{
  content:'';
  height:100%;
  width:1px;
  background:var(--color-neutral-lighter);
  right:47px;
  position:absolute;
  top:0px;
}

.list-item.mobile{
  border-bottom:1px solid var(--color-neutral-lighter);
  margin-bottom:-1px;
}

.list-item--main.mobile[engaged],
.list-item.mobile[engaged]{
  background-color:var(--color-neutral-white);
}

.list-item--main.mobile[engaged] .list-item--button-icon-mobile:before, .list-item.mobile[engaged] .list-item--button-icon-mobile:before{
    content:none;
  }

.list-item--main.mobile[engaged] .list-item--button.mobile, .list-item.mobile[engaged] .list-item--button.mobile{
    border-bottom:1px solid var(--color-neutral-lighter);
    justify-content:flex-start;
    column-gap:0.5rem;
  }

.list-item--button.mobile:focus{
  outline:solid 2px var(--color-primary-default);
  outline-offset:-1px;
}

.list-item--sub-menu.mobile{
  display:none;
  padding:0.5rem 1rem;
}

.list-item--main.mobile[engaged] > .list-item--sub-menu.mobile,
.list-item.mobile[engaged] > .list-item--sub-menu.mobile{
  display:flex;
  min-width:min-content;
  left:0;
  top:100%;
  row-gap:0;
  padding:0;
}

.list-item--main.mobile[engaged]
  > .list-item--sub-menu.mobile
  li:not(.list-item--special-link),
.list-item.mobile[engaged]
  > .list-item--sub-menu.mobile
  li:not(.list-item--special-link){
  margin-left:1rem;
}

.list-item.mobile[engaged]{
  position:absolute;
  top:0;
  left:0;
}

.list-item--main.mobile[engaged] > .list-item--sub-menu.mobile{
  padding:0;
}

.list-item--main.mobile[engaged]
  > .list-item--sub-menu.mobile
  li:not(:last-of-type),
.list-item.mobile[engaged] > .list-item--sub-menu.mobile li:not(:last-of-type){
  border-bottom:solid 1px var(--color-neutral-lighter);
}

.list-item--sub-menu.columns.mobile li{
  margin-bottom:0;
}

.list-item--special-link{
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:700;
  width:100%;
}

.list-item--special-link a{
    width:100%;
    height:100%;
    display:block;
    padding:1rem;
  }

.list-item--special-link a:focus{
    outline:solid 2px var(--color-primary-default);
    outline-offset:-1px;
  }

.flyaway{
  transform:translateX(-150%);
  visibility:hidden;
  opacity:0;
  margin:0 !important;
  height:0 !important;
  border:none !important;
  padding:0 !important;
}

.list-item--button-icon{
  pointer-events:none;
}
`;